export enum ReferenceLookupValue {
  AddressTypeCode = 'addressTypeCode',
  BankCode = 'bankCode',
  BankAccountType = 'bankAccountType',
  Usage = 'usage',
  IdTypeCode = 'idTypeCode',
  DebitOrderDay = 'debitOrderDay',
  NtuReason = 'ntuReason',
  MissingInformation = 'missingInformation',
  ContactTypeCode= 'contactTypeCode',
  QuestionCode= 'questionCode',
  AssociationCode= 'associationCode',
  RelationshipTypeCode= 'relationshipTypeCode',
  MaritalStatus= 'maritalStatus',
  Title= 'title',
  Gender= 'gender',
  Language = 'language',
  Ethnicity = 'ethnicity',
  DirectPayingMember= 'directPayingMember',
  BonCapProductCode= 'productCode' // BCAP ProductCodes
}
